export const ADD_AREAS = 'ADD_AREAS'
export const ADD_AREA = 'ADD_AREA'
